import { createStyles, Theme } from '@material-ui/core'

export const styles = (theme: Theme) =>
  createStyles({
    card: {
      '&.MuiCard-root': {
        margin: theme.spacing(0, 0, 2, 0)
      }
    },
    formRow: {
      display: 'flex',
      alignItems: 'flex-end',
      gap: '16px'
    },
    searchButtonContainer: {
      paddingBottom: '8px',
      flexShrink: 0
    },
    formStyleWrapper: {
      marginBottom: '16px',
      marginLeft: '16px',
      marginRight: '16px',
      // handle comments input height
      '& textarea#comments': {
        minHeight: '150px !important',
        maxHeight: '300px !important',
        resize: 'vertical',
        overflow: 'auto',
        height: '150px !important'
      }
    },
    formDialogContentCustom: {
      display: 'flex',
      alignItems: 'flex-end',
      gap: '16px',
      padding: '0px 0px 0px 0px',
      '&.MuiCardContent-root:last-child': {
        paddingBottom: 0
      },
      '&.MuiDialogContent-root:first-child': {
        paddingTop: 0
      },
      // Eliminar min-height del Toolbar del Form (espacio en blanco debajo del título)
      '& .MuiToolbar-regular': {
        minHeight: '0px !important',
        '@media (min-width: 0px) and (orientation: landscape)': {
          minHeight: '0px !important'
        },
        '@media (min-width: 600px)': {
          minHeight: '0px !important'
        }
      },
      // Eliminar padding del último CardContent (espacio en blanco al final del formulario)
      // sirve si hay otro componente debajo y queremos que parezca un solo bloque sin espacios
      '& .MuiCardContent-root:last-child': {
        paddingBottom: '0px !important'
      }
    }
  })
